import { Component, OnInit, ViewChild, AfterViewInit, HostListener, Renderer2, ElementRef, Inject, PLATFORM_ID } from "@angular/core";
import { Observable } from "rxjs";
import { UserService } from "../../services/user.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { PipeTransform } from "@angular/core";
import moment from "moment-timezone";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { LoaderModalService } from "../../services/loader.service";
import { CartlengthService } from "../../services/cartlength.service";
import { CommonService } from "src/app/services/common.service";
import { BehaviorService } from "src/app/services/behaviour.service";
import { AppState } from "state/app.state";
import { Store } from "@ngrx/store";
import * as Actions from "state/app.actions";
import { isPlatformBrowser } from "@angular/common";
import { JQueryService } from "src/app/services/jquery.service";

declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, AfterViewInit, PipeTransform {
  @ViewChild("dynamicPlaceholder", { static: true }) input: ElementRef;

  categoryList$: Observable<any>;
  storeList$: Observable<any>;
  auth: any;
  mySubscription: any;
  promo: FormGroup;
  subCategoryMobile: any = [];
  subscriptions: any = [];
  topSearchArray: any = [];
  storeId: any;
  categoryList: any = [];
  storeName: any;
  marqueeText: any = [];
  cartLength = 0;
  CategoryId: any;
  cartProduct$: any;
  subCategoryId: any;
  cartSum: any;
  userName: string;
  quantity = [];
  categoryName = "";
  lat: any;
  lng: any;
  defaultUrl = "https://ams.iqmetrix.net/images/e02aa3c7-9b73-4153-b16b-5e8ab6ab1b2d";

  addressStreetNumber: any;
  addressPostalCode: any;
  addressRoute: any;
  addressLocality: any;
  addressAdministrationLevel: any;
  addressCountry: any;
  addressNeighborhood: any;
  addressCurrentLat: any;
  addressCurrentLong: any;
  addressFormattedAddress: any;
  addressSubLocality = "";
  governmentIDStatus = "";
  governmentIDMessage = "";
  cartMessageError = "";
  checkOutCartMessage = "";
  jun = moment();
  torrontoTime: any;
  est24Hours: any;
  currentHourMin: any;
  addressData: any;
  storeTiming: any;
  hideCartOption = true;
  timeSlotEnd = "";
  offlineCartProduct = [];
  addressString = "";
  spinnerForm: FormGroup;
  spinData = [];
  activeSpin = false;
  currentUrl = "";
  showGovernmentMessage = false;
  searchInput = "";
  isSearchShow: boolean = false;
  hideCloseBtn = false;
  outOfStockMessage = "";
  offlineDiscountIn: any;
  offineDiscountNumber: any;
  offlineDiscountOn: any;
  carts: any = [];
  calculateOfflineDiscount = 0;
  offlineDeliveryCharge = 0;
  backendDeliveryCharge = 0;
  storeMobile = "6477252779";
  PickUpData;
  userId: string;
  addressCountryCode: string;
  status: any;
  formattedAddress: any[];
  pickupAddress: any;
  addressState: string;
  addressCity: string;
  categoryListl$: Observable<any>;
  serverCategoryList: any;
  displayCategoryList: any[];
  selectedStoreName: any;
  selectedStoreAddress: string;
  marker = true;
  storeDetails: any;
  loginForm: FormGroup;
  addressStatus: string;
  addressLatitude: string;
  addressLongitude: string;
  postalCode: string;
  city: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  dilveryStatus: string;
  mobile: string;
  email: string;
  registerForm: FormGroup;
  showReferralField: boolean;
  showAffilateField: boolean;
  submitted: boolean;
  mobileNumber = "";
  otpForm: FormGroup;
  verificationOTPForm: FormGroup;
  step: number;
  otpSubmitted: boolean;
  subCategoryName: any;
  selectedDay: any;
  selectedDate: any;
  selectedMillSecond: any;
  subCatList: any = [];
  choosenTimeSlot = "";
  selectedDeliveryTimeSlot = "";
  selectedTimeSlotDifference = "";
  slotColor = "#000";
  checkoutpart2Subtotal: any;
  checkoutpart2dilvery: any;
  checkoutpart2grandtotal: any;
  checkoutpart2tax: any;
  suggestionSearchList: any[];
  siteDada: any;
  isBrowser: boolean
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private commonService: CommonService,
    private userSrv: UserService,
    private router: Router,
    private loaderSrv: LoaderModalService,
    private cartLengthService: CartlengthService,
    private bs: BehaviorService,
    private storeState: Store<AppState>,
    private jQueryServ: JQueryService,

    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      setTimeout(() => {
        this.siteDada = JSON.parse(localStorage.getItem("siteData"));
        let siteDada = JSON.parse(localStorage.getItem("siteData"));
        if (siteDada != undefined && siteDada != null && siteDada != "") {
          this.siteDada = siteDada;
        }
      }, 300);
    }

  }

  createForm() {
    this.promo = this.fb.group({
      permo: ["", Validators.required],
    });
  }

  transform(username: string, args: any[]): string {
    return username.split("")[0];
  }

  canRequest;

  //google add
  newStoreHandle;
  currentstoreHandle;
  currentAddres;

  qtyValue;
  StoreClosed;
  tagList2 = [];
  progressbarWidth;
  showTimeSlotDiv;
  isPickup;
  guestProgressbarWidth;
  showLoading;
  // defaultUrl
  COLOR;
  emptyArr;
  modalText;
  weekday;
  varqtyvalue;
  SPECIESLIST;

  showScroll: boolean;
  showScrollHeight = 200;
  hideScrollHeight = 200;

  @HostListener("window:scroll", [])

  onWindowScroll(): void {
    if (isPlatformBrowser(this.platformId)) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (scrollTop > this.showScrollHeight) {
        this.showScroll = true;
      } else if (this.showScroll && scrollTop < this.hideScrollHeight) {
        this.showScroll = false;
      }
    }
  }

  ngOnInit(): void {

    this.getPromoDetails()
    if (this.isBrowser) {
      let val = localStorage.getItem("categoryList");
      if (val != "undefined" && val != undefined) {
        this.categoryList = JSON.parse(val);
      }
    }


    // SSR for side nav modal
  if (this.isBrowser) {
      (window as any).openNav = function () {
        const sidenav = document.getElementById("mySidenav");
        if (sidenav) {
          sidenav.style.width = "350px";

          // Optional: for smaller screens
          const x = window.matchMedia("(max-width: 580px)");
          if (x.matches) {
            sidenav.style.width = "100%";
          }
        }
      };

      (window as any).closeNav = function () {
        // Example logic from your earlier code, modify as needed
        document.querySelectorAll('a').forEach((el) => {
          el.addEventListener('click', () => {
            const id = el.getAttribute('id');
            if (id === "isDeals") {
              localStorage.setItem("isAllDeals", "true");
            } else {
              localStorage.setItem("isAllDeals", "false");
            }
          });
        });

        const sidenav = document.getElementById("mySidenav");
        if (sidenav) {
          sidenav.style.width = "0";
        }
      };
    
    
  }

    this.getsuggestionSearchList();

    this.getMarqueeData();
    this.commonService.getCategoryList()?.subscribe((res: any) => {
      this.categoryList = res.data;
      this.bs.setCat(this.categoryList);
      if (this.isBrowser) {
        localStorage.setItem("categoryList", JSON.stringify(this.categoryList));

      }
    });

    if (this.cartLengthService.subsVar == undefined) {
      this.cartLengthService.subsVar = this.cartLengthService.cartLengthUpdate?.subscribe((value: Number) => {
        this.cartLengthUpdate(value);
      });
    } else {
      this.cartLengthService.subsVar = this.cartLengthService.cartLengthUpdate?.subscribe((value: Number) => {
        this.cartLengthUpdate(value);
      });
    }

    this.canRequest = true;
    this.varqtyvalue = 0;

    if (this.isBrowser) {
      this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
      this.CartBarLimit = Number(localStorage.getItem("CartBarLimit"));
    }
    if (this.isBrowser) {

      this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.getAddressStatus() === undefined || this.getAddressStatus() === null) {
        this.jQueryServ.showModal('#selectOrderStatusPopup');

        return;
      } else {
        this.emptyArr = [];
        this.modalText = "";
        this.COLOR = "";
        this.showTimeSlotDiv = false;
        this.showLoading = false;

        this.guestCartWeight = 0;
        this.isPickup = JSON.parse(localStorage.getItem("isPickUpOrder"));
        this.progressbarWidth = "25%";
        this.guestProgressbarWidth = "0%";
        this.defaultUrl = "assets/images/defaultimg.jpeg"; //default image

        this.qtyValue = 1;
        this.isPickup = localStorage.getItem("isPickUpOrder");
        if (this.isPickup == "true") {
          this.modalText = "pickup";
        } else {
          this.modalText = "delivery";
        }

        this.StoreClosed = false;
        this.userName = localStorage.getItem("userName");
        this.getStoreDetail();

        if (localStorage.getItem("addressString") === undefined || localStorage.getItem("addressString") === null) {
          this.hideCloseBtn = false;
        } else {
          this.hideCloseBtn = true;
        }
        if (localStorage.getItem("isPickUpOrder") === undefined || localStorage.getItem("isPickUpOrder") === null) {
          this.jQueryServ.showModal('#selectOrderStatusPopup');
        } else {
          if (this.getAddressStatus() === undefined || this.getAddressStatus() === null) {
            this.jQueryServ.showModal('#SearchLocation');;
            this.isPickup = localStorage.getItem("isPickUpOrder");
          }
        }

        if (isPlatformBrowser(this.platformId)) {
          $(window).on("scroll", function () {
            let top = $(window).scrollTop();
            if (top >= 30) {
              $(".sticky-header").addClass("fixed");
              $(".select-address-header").addClass("fixed");
            } else {
              $(".sticky-header").removeClass("fixed");
              $(".select-address-header").removeClass("fixed");
            }
          });
        }

        this.checkValueInSearch();
        this.createForm();
        this.addressString = localStorage.getItem("addressString");

        this.storeList$ = this.commonService.getStoreList();

        if (this.getLocalStoreId() === null || this.getLocalStoreId() === undefined) {
          if (localStorage.getItem("isPickUpOrder") === undefined || localStorage.getItem("isPickUpOrder") === null) {
            this.jQueryServ.showModal('#selectOrderStatusPopup');
          } else {
            if (this.getAddressStatus() === undefined || this.getAddressStatus() === null) {
              this.jQueryServ.showModal('#SearchLocation');;
            }
          }
        } else {
          let obj = {
            storeId: Number(this.getLocalStoreId()),
            storeName: localStorage.getItem("localStoreName"),
            storeEmail: localStorage.getItem("storeEmail"),
          };
          this.storeId = Number(this.getLocalStoreId());
          this.storeName = localStorage.getItem("localStoreName");

          this.storeMobile = localStorage.getItem("storeMobile");
          this.userSrv.updateStoreDetails(obj);
        }
        this.mySubscription = this.userSrv.getAuth().subscribe((res) => {
          //logeed in user
          this.auth = res;
          if (this.auth) {
            this.userName = localStorage.getItem("userName");
          }
          this.checkUserEmailIDStatus();
          this.getAddress();
          if (res) {
          }
          if (localStorage.getItem("addressData") !== null) {
            this.saveUserAddressAfterLogin();
          }
          this.commonService.emitCartData().subscribe((data) => {
            if (this.auth) {
              this.getCartProduct();
            } else {
              this.getOfflineProduct();
            }
          });
        });
        this.mySubscription.unsubscribe();
        for (var i = 1; i <= 50; i++) {
          this.quantity.push(i);
        }
        this.userSrv.getShopLink().subscribe((res) => {
          this.currentUrl = this.router.url;
          this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
            this.currentUrl = this.router.url;
          });
          if (res === null || res === "") {
            this.categoryName = "";
          } else {
            this.categoryName = res;
          }
        });
        this.selectedStoreName = localStorage.getItem("localStoreName");
        this.selectedStoreAddress = localStorage.getItem("addressString");
        this.isShown = false; //collect varient data
        this.showVariance = false;
      }
    }

  }

  getAddressStatus() {
    if (this.isBrowser) {
      return localStorage.getItem('addressStatus')
    }
  }

  getPromoDetails() {
    const options: any = { weekday: 'long' };
    const todayFormatted = new Date().toLocaleDateString('en-US', options);
    this.commonService.Get(`/promo/getpromobyday?day=${todayFormatted}`).subscribe((res) => {
      if (res["meta"]["status"]) {
        this.storeState.dispatch(
          new Actions.Add({
            currentActivePromo: res?.data,
          })
        );
      }
    });
  }

  //--------onit end here----------------------------------------------------


  getMarqueeData() {
    if (this.isBrowser) {
      $("#maindiv").width($("#div1").width());
      let storeId = this.getLocalStoreId();
      this.commonService.getMarqueeData(storeId).subscribe((res: any) => {
        if (res?.data && res?.data?.length) {
          let marqueeText = res?.data.filter(itm => itm.status == 'ACTIVE')
          this.marqueeText = marqueeText?.sort((a, b) => a?.sort - b?.sort);
        }
      });
    }

  }
  getColor() {
    if (this.isBrowser) {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
 
    let style: any;
    if (this.siteDada?.headerColor) {
      style = { background: this.siteDada?.headerColor };
    } else {
      style = { background: "#000" };
    }
    return style;
  }
   }
  getMarqueeColor() {
    let style: any;
    if (this.isBrowser) {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));

    }
    if (this.siteDada?.marqueeColor) {
      style = {
        background: this.siteDada?.marqueeColor,
        height: "38px",
      };
    } else {
      style = { background: "#000", height: "38px" };
    }
    return style;
  }

  getTextIconColor(sty, type?) {
    let style: any;
    if (this.isBrowser) {
      this.siteDada = JSON.parse(localStorage.getItem("siteData"));
      this.renderer.setStyle(this.input.nativeElement, "--placeholder-color", this.siteDada?.headerTextColor);
    }

    if (this.siteDada?.headerTextColor) {
      // style = {
      //   color: this.siteDada?.headerTextColor,
      // };
      style = sty;
    } else {
      style = { color: "#fff" };
    }
    if (type == "subcat" && !this.siteDada?.headerTextColor) {
      style = { color: "#000" };
    }
    if (type == "subcatMobile" && !this.siteDada?.headerTextColor) {
      style = { color: "#fff" };
    }
    return style;
  }

  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {

      (function smoothscroll() {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          if (this.isBrowser) {
            window.requestAnimationFrame(smoothscroll);
            window.scrollTo(0, currentScroll - currentScroll / 5);
          }
        }


      })();
    }
  }

  getsuggestionSearchList() {
    this.commonService.getSuggestionSearchList().subscribe((res) => {
      this.suggestionSearchList = res["data"];
    });
  }

  logoFunction() {
    // this.getAddress();
  }

  //order api
  usercvvError;
  loginModeOn: Boolean = false;
  userExpiryrError;
  orderDetail;
  canShowThankyoupage: Boolean = false;

  hidecart() {
    if (this.isBrowser) {
      if (this.auth) {
        this.jQueryServ.hideModal('#shoppingCart')
        this.canShowThankyoupage = false;
        this.showLoginStaffPick = true;
        this.loginModeOn = false;
      } else {
        this.jQueryServ.hideModal('#shoppingCart')
        this.canShowThankyoupage = false;
        this.loginModeOn = false;
        this.showTimeSlotDiv = false;
        // for guest
        this.cartLength = 0;
        this.guestProgressbarWidth = "0%";
        localStorage.removeItem("cartProduct");
      }
    }

  }

  cartLengthUpdate(number) {
    this.cartLength = number;
  }

  hoverindex;
  setshophoverindex(index) {
    this.hoverindex = index;
  }

  sortFuncForSubcat(a, b) {
    // const nameA = a.subCategoryName.toUpperCase(); // ignore upper and lowercase
    // const nameB = b.subCategoryName.toUpperCase(); // ignore upper and lowercase
    const nameA = a.subCategoryName; // ignore upper and lowercase
    const nameB = b.subCategoryName; // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  }
  actualId;
  isShown;
  varianceArray = [];
  showVariance;
  storeTime;

  checkValueInSearch() {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.searchInput = res["search"];
    });
  }



  getAddress() {
    if (this.isBrowser) {

      if (this.auth) {
        let covaid = localStorage.getItem("covaUserId");
        let obj = {
          CustomerId: covaid,
        };
        this.commonService.getUserLocation(obj).subscribe((res) => {
          if (res["meta"]["status"]) {
            let addressId = res["data"][0].Id;
            localStorage.setItem("addressId", addressId);
          } else {
            localStorage.removeItem("addressId");
          }
        });
      } else {
        this.addressString = localStorage.getItem("addressString");
      }
    }
  }

  ngAfterViewInit() {
    this.userSrv.getStore().subscribe((res) => {
      if (res === null) {
        this.storeId = "";
        this.storeName = "";
      } else {
        this.storeId = Number(res["storeId"]);
        this.storeName = res["storeName"];
      }
    });
  }

  showLoginStaffPick: Boolean = false;
  recommendedProductsList;
  weightLimit;
  CompareWithSubTotal;
  CartSubTotal;
  CartBarLimit;
  logincartProduct;
  getCartProduct() {
    if (this.isBrowser) {

      var isSwitchStatus = false;
      var storeID = this.getLocalStoreId();
      if (localStorage.getItem("isSwitch") == "true") {
        isSwitchStatus = true;
      } else {
        isSwitchStatus = false;
      }
      this.cartProduct$ = this.commonService.getUserCartProduct(isSwitchStatus, storeID).subscribe((res: any) => {
        this.logincartProduct = res;
        if (res["meta"]["status"]) {
          localStorage.setItem("isSwitch", "false");
          this.weightLimit = res["wtSum"];
          let percentage = (this.weightLimit / this.CartBarLimit) * 100;

          if (res["minimumCartValuebyCity"]) {
            this.CompareWithSubTotal = res["minimumCartValuebyCity"].amount;
            this.CartSubTotal = Number(res["subTotal"]);
          }
          if (this.weightLimit) {
            this.progressbarWidth = String(percentage.toFixed(0)) + "%";
          } else {
            this.progressbarWidth = String(percentage.toFixed(0) + "%");
          }
          localStorage.setItem("cartLimit", this.weightLimit);
          this.recommendedProductsList = res["RecomendedProducts"];
          this.showLoginStaffPick = true;
          if (res["data"] && res["data"]["addtoCart"] && res["data"]["addtoCart"].length === 0) {
            this.cartLength = 0;
            localStorage.setItem("loggedInCart", String(this.cartLength));
            this.commonService.updateCartProduct(0);
            this.cartSum = "$" + 0;
            this.cartMessageError = "";
            this.userSrv.updateCartMessage("");
          } else {
            this.cartLength = res["data"]["addtoCart"].length;
            localStorage.setItem("loggedInCart", String(this.cartLength));
            this.carts = res["data"]["addtoCart"];
            this.commonService.updateCartProduct(res["data"]["addtoCart"].length);
            this.cartSum = "$" + Number(res.grandTotal).toFixed(2);
          }
        } else {
          this.cartLength = 0;
          this.weightLimit = 0;
          localStorage.setItem("cartLimit", this.weightLimit);
          localStorage.setItem("loggedInCart", String(this.cartLength));
          this.commonService.updateCartProduct(0);
          this.cartSum = "$" + 0;
          this.cartMessageError = "";
          this.userSrv.updateCartMessage("");
        }
      });
    }
  }
  guestCartWeight;
  getOfflineProduct() {

    if (this.isBrowser) {

      if (localStorage.getItem("cartProduct") === null) {
        this.cartLength = 0;
        this.guestProgressbarWidth = "0%";
        localStorage.removeItem("cartProduct");
      } else {
        let offlineProduct = JSON.parse(localStorage.getItem("cartProduct"));
        this.offlineCartProduct = offlineProduct["product"];
        //
        if (this.offlineCartProduct.length === 0) {
          localStorage.removeItem("cartProduct");
          this.guestProgressbarWidth = "0%";
          this.cartLength = 0;
        }

        this.cartLength = this.offlineCartProduct.length;
        let currentcartWeight = 0;
        offlineProduct["product"].forEach((cartPd) => {
          currentcartWeight = currentcartWeight + cartPd.weight * cartPd.quantity;
          this.guestCartWeight = Number(currentcartWeight);
        });

        //bar get
        let percentage = (currentcartWeight / this.CartBarLimit) * 100;
        if (currentcartWeight) {
          this.guestProgressbarWidth = String(percentage.toFixed(0)) + "%";
        } else {
          this.guestProgressbarWidth = String(percentage.toFixed(0) + "%");
        }
        localStorage.setItem("cartLimit", this.weightLimit);

        if (this.cartLength >= 1) {
          this.getRecommendedProduct(); //get recommended --call
        }
        this.commonService.updateCartProduct(this.cartLength);
        //this.offlineCartProduct['product'].length
      }
    }
  }



  RECOMMNEDLIST;
  getRecommendedProduct() {
    let addedProductIds = [];
    if (this.offlineCartProduct.length) {
      this.offlineCartProduct.forEach((elm) => {
        addedProductIds.push(elm.productId);
      });
    }
    //
    let obj = {
      storeId: this.storeId,
      categoryId: 2543,
      addedProductIds: addedProductIds,
      resPerPage: 3,
      page: 1,
    };

    this.commonService.getRecommendedPro(obj).subscribe((res) => {
      this.RECOMMNEDLIST = res["data"];
      // ;
    });
  }

  openLogin() {
    if (isPlatformBrowser(this.platformId)) {
      const sideRegister = document.getElementById("mySideRegister");
      const sideLogin = document.getElementById("mySideLogin");
      if (sideRegister) sideRegister.style.width = "0";
      if (sideLogin) sideLogin.style.width = "450px";

      function myFunction(x: MediaQueryListEvent | MediaQueryList) {
        if (x.matches) {
          if (sideLogin) sideLogin.style.width = "100%";  // use "100%" instead of calc(100%)
        } else {
          if (sideLogin) sideLogin.style.width = "450px";  // reset if not matched
        }
      }

      const x = window.matchMedia("(max-width: 580px)");
      myFunction(x);
      x.addEventListener("change", myFunction);
    }
  }

  openLogoutPopUp() {
    this.jQueryServ.showModal('#logoutPopUp');
  }

  currentOrderType: String = "";
  newOrderType: String = "";
  toChangeStatus;



  pickUpStatus;
  orderType;
  //add var. or not
  showMinusOrPlus: Boolean = false;
  showVarincePrice: Boolean = true;
  isSabCatVisible: Boolean = false;
  canichangethecategory: Boolean = true;
  redirectToShopPage(list) {

    this.categoryName = list.categoryName;
    let categoryNameWithId = list.categoryName + "_" + list.slug;
    if (this.categoryName === "New Arrivals") {
      this.router.navigateByUrl("/shop/NewArrivals");
      return;
    }
    if (this.categoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
    }
    this.openSubCat(list);
  }
  redirectToShopPageForMobile(categoryName, categoryId) {
    this.categoryName = categoryName;
    let categoryNameWithId = categoryName + "_" + categoryId;
    if (this.categoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
      this.userSrv.updateShopLink(categoryNameWithId);
    }
  }
  redirectToShopPageWithSubCategoryId(list, category) {
    this.subCatClick = false;
    this.subCategoryName = list.subCategoryName;
    let subCategoryNameWithId = category?.slug + "_" + list.slug;
    this.subCatList = []
    if (this.subCategoryName == "All Flowers") {
      this.categoryName = "Flower";
      let categoryNameWithId = "Flower_flower";
      this.router.navigateByUrl("/shop/" + categoryNameWithId);
      this.userSrv.updateShopLink(categoryNameWithId);
      return;
    }

    if (this.subCategoryName === "All") {
      this.router.navigateByUrl("/shop");
      this.userSrv.updateShopLink("All");
    } else {
      this.router.navigateByUrl("/shop/subProduct/" + subCategoryNameWithId);
    }
  }


  checkUserEmailIDStatus() {
    this.userSrv.getAuth().subscribe((res) => {
      if (res) {
        this.userSrv.getUserAddedFromCSV().subscribe((x) => {
          if (x !== null) {
            if (x.userStatus === true) {
              if (x.emailVerified === false) {
                this.router.navigateByUrl("/verify/verify-email");
              } else {
                this.router.navigateByUrl("/verify/change-password");
              }
            }
          }
        });
      }
    });
  }


  newStoreHoursFormat(hour, min) {
    var newFormatedValue = hour + ":" + min;
    return moment(newFormatedValue, ["HH:mm"]).format("h:mm A");
  }

  openShoppingCart() {
    this.bs.setStep(1);
    if (!this.auth) {
      this.getOfflineProduct();
    }
    if (this.isBrowser) {
      this.jQueryServ.showModal('#shoppingCart');
    }

  }


  saveUserAddressAfterLogin() {
    if (this.isBrowser) {

      let addressData = JSON.parse(localStorage.getItem("addressData"));
      this.getAddressFromLocalStorage(addressData.name, addressData.address_components, addressData.geometry.location, addressData.formatted_address);
    }
  }

  getAddressFromLocalStorage(streetName, addressComponents, geometry, formattedAddress) {
    this.addressCurrentLat = geometry.lat;
    this.addressCurrentLong = geometry.lng;
    this.addressFormattedAddress = formattedAddress;
    this.addressStreetNumber = streetName;
    addressComponents.map((item) => {
      item.types.map((data) => {
        if (data === "postal_code") {
          this.addressPostalCode = item.long_name;
        } else if (data === "neighborhood") {
          this.addressNeighborhood = item.long_name;
        } else if (data === "locality") {
          this.addressLocality = item.long_name;
        } else if (data === "administrative_area_level_1") {
          this.addressAdministrationLevel = item.short_name;
        } else if (data === "country") {
          this.addressCountry = item.long_name;
        } else if (data === "route") {
          this.addressRoute = item.long_name;
        }
      });
    });
  }

  dateArray = [];
  getDateArrayPickup() {
    this.dateArray = [];
    if (this.isBrowser) {

      for (var i = 0; i <= 1; i++) {
        let date;
        let days;
        let milliSecond;
        if (i === 0) {
          days = moment.tz("America/Los_Angeles").format("dddd");
          date = moment.tz("America/Los_Angeles").format("YYYY-MM-DD");
          milliSecond = moment.tz(date, "America/Los_Angeles").startOf("day").valueOf();
          this.dateArray.push({
            date: date,
            day: days,
            milliSecond: milliSecond,
            same: 0,
          });
          // this.shimmerShow = false
        } else {
          days = moment.tz("America/Los_Angeles").add(i, "days").format("dddd");
          date = moment.tz("America/Los_Angeles").add(i, "days").format("YYYY-MM-DD");
          milliSecond = moment.tz(date, "America/Los_Angeles").startOf("day").valueOf();
          this.dateArray.push({
            date: date,
            day: days,
            same: 1,
            milliSecond: milliSecond,
          });
          // this.shimmerShow = false
        }
      }
      this.selectedDay = this.dateArray[0]?.day;
      this.selectedDate = this.dateArray[0]?.date;
      this.selectedMillSecond = this.dateArray[0]?.milliSecond;
    }
  }

  userCreditcardError;


  suggList: Boolean = false;
  tapOnSearchBar(event) {
    event.stopPropagation();
    this.suggList = true;
  }
  searchProduct(value) {
    let d1: any;
    this.suggList = false;
    if (value === "") {
      this.router.navigateByUrl(`/shop`);
    } else if (value == "allflowers") {
      this.router.navigateByUrl(`/shop/Flower_flower`);
    } else if (value == 'alledibles') {
      this.router.navigateByUrl(`/shop/Edibles_edibles`);
    } else if (value == 'newarrivals') {
      this.router.navigateByUrl(`/shop/NewArrivals`);
    } else if (value == 'deals') {
      this.router.navigateByUrl(`/shop/deals`);
    } else {
      d1 = value.replaceAll(/ /g, " ");
      this.router.navigateByUrl(`/shop/all?search=${d1}`);
    }
    this.bs.setSearch(d1);
  }


  out() {
    this.searchIn = false;
    this.showNoResult = false;
    this.suggList = false;
  }

  @HostListener("document:click", ["$event"]) onDocumentClick() {
    this.searchIn = false;
    this.showNoResult = false;
    this.suggList = false;
  }

  @HostListener("document:keypress", ["$event"]) onDocumentKeypree() {
    this.suggList = false;
  }
  stopPendingRequest() {
    if (this.subscriptions?.length > 0) {
      this.subscriptions?.map((subscription, i) => {
        subscription?.unsubscribe();
        this.subscriptions = [];
      });
    }
  }

  searchIn: boolean = false;
  showNoResult: boolean = false;
  search_suggestionArr;
  searchSuggest(event) {
    this.stopPendingRequest();

    event.stopPropagation();
    let searchValue = event.target.value;
    if (searchValue == "") {
      this.topSearchArray = [];
    }
    this.showNoResult = false;
    this.suggList = true;
    if (searchValue?.length == 0) {
      this.searchIn = false;
      this.showNoResult = false;
      return (this.search_suggestionArr = []);
    }
    if (this.suggestionSearchList?.length) {
      this.topSearchArray = [];
      this.suggestionSearchList.forEach((res) => {
        if (res?.name?.toLowerCase().match(searchValue?.toLowerCase())) {
          this.topSearchArray.push(res);
        }
      });
      if (this.topSearchArray?.length == 0) {
        if (searchValue.length >= 2) {
          let obj = {
            storeId: Number(this.getLocalStoreId()),
            searchKey: searchValue,
            resPerPage: 10,
            page: 1,
          };
          let product: any = this.commonService.searchSingleProductnew(obj).subscribe((res) => {
            if (res["data"]) {
              if (res["data"].length) {
                this.searchIn = true;
                this.search_suggestionArr = res["data"];
              } else {
                this.search_suggestionArr = [];
                this.showNoResult = true;
                this.searchIn = false;
              }
            } else {
              this.showNoResult = true;
              this.searchIn = false;
              this.search_suggestionArr = [];
            }
          });
          this.subscriptions.push(product);
        }
      }
    }
  }

  hideSearchDiv() {
    this.searchIn = false;
  }

  getLocalStoreId() {
    if (this.isBrowser) {
      return localStorage.getItem('localStoreId');
    }
  }

  dilverytime;
  getStoreDetail() {
    const obj = {
      Id: Number(this.getLocalStoreId()),
    };
    this.commonService.getStoreDetail(obj).subscribe((res) => {
      this.storeDetails = res["data"];
      let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.storeDetails && this.storeDetails["StoreHours"]) {
        let a = this.storeDetails["StoreHours"][weekday];
        let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
        var currentTime = moment(new Date());
        var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
        var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute
        var endTime: any
        var beginningTime = moment(StoreOpenTime, 'HH:mm');
        if (StoreCloseTime == '0:0') {
          StoreCloseTime = '24:0'
        }
        if (a.Close.Hour < a.Open.Hour && a.Close.Hour != '0') {
          endTime = moment(StoreCloseTime, 'HH:mm').add(1, 'day')
        } else {
          endTime = moment(StoreCloseTime, 'HH:mm');
        }

        if (currentTime > beginningTime && currentTime < endTime) {
          this.StoreClosed = false;
        } else {
          this.StoreClosed = true;
        }
        if (a) {
          this.storeTime = a;
          this.dilverytime = dilveryHoursObj;
          if (this.isBrowser) {
            localStorage.setItem("storeTiming", JSON.stringify(a));
          }
        }
      }
    });
  }

  modalOpen() {
    if (this.isBrowser) {
      this.jQueryServ.showModal('#storeHistoryModal');
    }
  }

  openMobileVerify() {
    if (isPlatformBrowser(this.platformId)) {
      const sideLogin = document.getElementById("mySideLogin");
      const sideRegister = document.getElementById("mySideRegister");
      const sideMobileVerify = document.getElementById("mySideMobileVerify");

      if (sideLogin) sideLogin.style.width = "0";
      if (sideRegister) sideRegister.style.width = "0";
      if (sideMobileVerify) sideMobileVerify.style.width = "450px";

      function myFunction(x: MediaQueryList | MediaQueryListEvent) {
        if (sideMobileVerify) {
          if (x.matches) {
            sideMobileVerify.style.width = "100%";  // "calc(100%)" not necessary here
          } else {
            sideMobileVerify.style.width = "450px"; // reset width if media query does not match
          }
        }
      }

      const x = window.matchMedia("(max-width: 580px)");
      myFunction(x);
      x.addEventListener("change", myFunction); // listen to media query changes properly
    }
  }



  get f() {
    return this.otpForm.controls;
  }

  get o() {
    return this.verificationOTPForm.controls;
  }

  subCatClick: boolean = true;

  openSubCat(item) {
    this.subCatClick = true;
    this.subCategoryMobile = item;
    if (item?.subCategory == undefined || item?.subCategory?.length == 0) {
      this.subCatList = [];
      this.redirectToShopPageForMobile(item?.categoryName, item?.slug);
    } else {
      if (this.subCatList == item?.subCategory) {
        this.subCatList = [];
      } else {
        this.subCatList = item?.subCategory;
      }
    }
  }
}

export interface Search {
  img: string;
  name: string;
}

interface User {
  userId: string;
  mobileVerified: string;
  firstName: string;
  lastName: string;
  documentVerify: string;
}

interface Token {
  token: string;
}
